import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-498142aa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "charts" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      ($setup.layoutLimit('pie'))
        ? (_openBlock(), _createBlock($setup["pie"], {
            key: 0,
            ref: "pieRef",
            class: "chart charts-pie"
          }, null, 512 /* NEED_PATCH */))
        : _createCommentVNode("v-if", true),
      ($setup.layoutLimit('bar'))
        ? (_openBlock(), _createBlock($setup["bar"], {
            key: 1,
            ref: "barRef",
            class: "chart charts-pie"
          }, null, 512 /* NEED_PATCH */))
        : _createCommentVNode("v-if", true),
      ($setup.layoutLimit('line'))
        ? (_openBlock(), _createBlock($setup["line1"], {
            key: 2,
            ref: "lineRef",
            class: "chart charts-pie"
          }, null, 512 /* NEED_PATCH */))
        : _createCommentVNode("v-if", true),
      ($setup.layoutLimit('list'))
        ? (_openBlock(), _createBlock($setup["list"], {
            key: 3,
            class: "chart"
          }))
        : _createCommentVNode("v-if", true)
    ]),
    ($setup.layoutLimit('last-read'))
      ? (_openBlock(), _createBlock($setup["lastRead"], { key: 0 }))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}